<!-- 组件说明 -->
<template>
  <div>
    <van-sticky>
      <van-nav-bar
        :title="titleName"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
        class="nav_title"
      />
    </van-sticky>
    <div class="cont">
      <div class="rich_text" v-html="data"></div>
    </div>
  </div>
</template>

<script>
//import x from ''
import { NavBar } from "vant";
import goods from "@/api/goods";
import { mapMutations, mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      data: "",
      titleName: "",
    };
  },
  computed: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
  },
  created() {
    let param = this.$route.params || {};
    let id = param.id;
    // console.log('id',id)
    goods
      .topSiteList({
        shopId: sessionStorage.getItem("shopId"),
        region: sessionStorage.getItem("REG"),
      })
      .then((res) => {
        res.forEach((item, index) => {
          if (item.id == id) {
            this.data = item.content;
            this.titleName = item.title;
          }
        });
      });
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped='scoped'>
.cont {
  padding: 0 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/siteDetail.vue